import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import MatchHeight from './app/current-nav.js';
import jQueryMatchHeight from 'jquery-match-height/dist/jquery.matchHeight-min';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"

import SlickCarousel from 'slick-carousel';
import SlickCarouselCss from "slick-carousel/slick/slick-theme.scss";
import SlickCarouselCsss from "slick-carousel/slick/slick.scss";
//import Snap from 'snapsvg';
import Rellax from 'rellax';
import ScrollReveal from "scrollreveal"

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }

    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/assets/images/icon-slider-prev.png" />', '<img src="/assets/images/icon-slider-next.png" />'],
        });
      });
      //->カルーセル
      owls.imagesLoaded(function () {
        $('.c-main-visual__carousel').owlCarousel({
          items: 3,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/assets/images/icon-slider-prev.png" />', '<img src="/assets/images/icon-slider-next.png" />'],
        });
      });
    }

    $(function () {
      menuSlide();
      owlCarousel();
    });
  }
}

window.GApp = new App();


(function ($) {

  var growApp = function () {
  };
  /*
   * userAgent取得
   * */
  var Agent = window.navigator.userAgent.toLowerCase();
  var _ua = (function (u) {
    return {
      Tablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1)
        || u.indexOf("ipad") != -1
        || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
        || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
        || u.indexOf("kindle") != -1
        || u.indexOf("silk") != -1
        || u.indexOf("playbook") != -1,
      Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
        || u.indexOf("iphone") != -1
        || u.indexOf("ipod") != -1
        || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
        || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
        || u.indexOf("blackberry") != -1
    }
  })(Agent);

  growApp.prototype.changeViewPort = function () {

    //ビューポート処理
    if (_ua.Mobile) {
      $('head').prepend('<meta name="viewport" content="width=device-width,initial-scale=1">');
    } else {
      $('head').prepend('<meta name="viewport" content="width=1100">');
    }
  };

  /*
  *
  * スマホメニューの高さを取得する
  *
  * */
  growApp.prototype.menuHight = function () {
    var win = $(window).innerWidth();
    if (win > 750) {
      return false;
    }

    var $smpHeaderHeight = $('.l-header').height();
    var windowHeight = window.innerHeight;
    var winH = windowHeight - $smpHeaderHeight;

    console.log($smpHeaderHeight);

    //動かすターゲットを取得
    var targetSlidebarWrap = $('.c-slidebar-menu'),
      targetSlidebarMenu = $('.c-slidebar__parent'),
      targetSlidebarBtn = $('.c-slidebar-menu__parent');


    //いざ実行(クリックしたら処理を実行する)
    targetSlidebarBtn.on('click', function () {
      $('.c-slidebar-menu').toggleClass('is-active');

    });
  }

  growApp.prototype.footerMenu = function () {
    var win = $(window).innerWidth();
    if (win > 750) {
      return false;
    }
    $('.c-footer-menu__block').on('click', function () {
      $(this).children(".c-footer-menu__title").toggleClass('is-open');
      $(this).children(".c-footer-menu__list.is-sub").slideToggle();
    })
  }

  //buttonWrap
  growApp.prototype.buttonWrap = function () {
    var $button = $(".c-button,.c-button-text");
    $button.wrapInner("<span></span>");
  }

  //slick
  growApp.prototype.slick = function () {
    function slick() {
      $('.c-news-top__slider-inner').slick({
        //autoplay: true,
        autoplaySpeed: 4000,
        speed: 400,
        arrows: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        dots: false,
        //prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
        //nextArrow: '<div class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
        responsive: [{
          breakpoint: 950,
          settings: {
            centerMode: true,
            autoplaySpeed: 2500,
            slidesToShow: 1,
          }
        }]
      });

      //top
      var $serviceTop = $('.c-service-top__sliders');
      /*
      $serviceTop.on('beforeChange',function(){
          $(this).find(".c-service-top__texts").hide("");
      });
      $serviceTop.on('afterChange',function(){
          $(this).find(".slick-active .c-service-top__texts").fadeIn("4000");
      });*/
      $serviceTop.slick({
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 400,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: true,
        dots: true,
        prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
        nextArrow: '<div class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
        responsive: [{
          breakpoint: 950,
          settings: {
            autoplaySpeed: 2500,
            slidesToShow: 1,
          }
        }]
      });

    }

    slick();
  }

  //パーティクル
  growApp.prototype.particleAnim = function () {

    if ($("#particleAnim").length) {

      //パーティクル処理
      var canvas = $("#canvas");

      function anim() {
        var utils = {
          norm: function (value, min, max) {
            return (value - min) / (max - min);
          },

          lerp: function (norm, min, max) {
            return (max - min) * norm + min;
          },

          map: function (value, sourceMin, sourceMax, destMin, destMax) {
            return utils.lerp(
              utils.norm(value, sourceMin, sourceMax),
              destMin,
              destMax
            );
          },

          clamp: function (value, min, max) {
            return Math.min(Math.max(value, Math.min(min, max)), Math.max(min, max));
          },

          distance: function (p0, p1) {
            var dx = p1.x - p0.x,
              dy = p1.y - p0.y;
            return Math.sqrt(dx * dx + dy * dy);
          },

          distanceXY: function (x0, y0, x1, y1) {
            var dx = x1 - x0,
              dy = y1 - y0;
            return Math.sqrt(dx * dx + dy * dy);
          },

          circleCollision: function (c0, c1) {
            return utils.distance(c0, c1) <= c0.radius + c1.radius;
          },

          circlePointCollision: function (x, y, circle) {
            return utils.distanceXY(x, y, circle.x, circle.y) < circle.radius;
          },

          pointInRect: function (x, y, rect) {
            return (
              utils.inRange(x, rect.x, rect.x + rect.radius) &&
              utils.inRange(y, rect.y, rect.y + rect.radius)
            );
          },

          inRange: function (value, min, max) {
            return value >= Math.min(min, max) && value <= Math.max(min, max);
          },

          rangeIntersect: function (min0, max0, min1, max1) {
            return (
              Math.max(min0, max0) >= Math.min(min1, max1) &&
              Math.min(min0, max0) <= Math.max(min1, max1)
            );
          },

          rectIntersect: function (r0, r1) {
            return (
              utils.rangeIntersect(r0.x, r0.x + r0.width, r1.x, r1.x + r1.width) &&
              utils.rangeIntersect(r0.y, r0.y + r0.height, r1.y, r1.y + r1.height)
            );
          },

          degreesToRads: function (degrees) {
            return degrees / 180 * Math.PI;
          },

          radsToDegrees: function (radians) {
            return radians * 180 / Math.PI;
          },

          randomRange: function (min, max) {
            return min + Math.random() * (max - min);
          },

          randomInt: function (min, max) {
            return min + Math.random() * (max - min + 1);
          },

          getmiddle: function (p0, p1) {
            var x = p0.x,
              x2 = p1.x;
            middlex = (x + x2) / 2;
            var y = p0.y,
              y2 = p1.y;
            middley = (y + y2) / 2;
            pos = [middlex, middley];

            return pos;
          },

          getAngle: function (p0, p1) {
            var deltaX = p1.x - p0.x;
            var deltaY = p1.y - p0.y;
            var rad = Math.atan2(deltaY, deltaX);
            return rad;
          },
          inpercentW: function (size) {
            return size * W / 100;
          },

          inpercentH: function (size) {
            return size * H / 100;
          }
        };

        // basic setup  :)

        canvas = document.getElementById("canvas");
        var ctx = canvas.getContext("2d");
        var W = canvas.width = window.innerWidth;
        var H = canvas.height = window.innerHeight + 300;

        var gridX = 37;
        var gridY = 37;

        var messagetext = "∞";
        var messageoffset = 200;
        var gravity = 0;
        var duration = 0.1;
        var resolution = 0.01;
        var speed = 1;
        var radius = 1.1;
        var fontsize = 1200;
        var fontweight = "bold";
        var scrollV = 0;
        var _old_offset = 0;


        var win = $(window).innerWidth();
        if (win < 950) {
          fontsize = win + win * 0.1;
          gridX = 25;
          gridY = 25;
        }
        if (win < 750) {
          gridX = 25;
          gridY = 25;
          radius = 1;
          messageoffset = 100;
          fontweight = "bold";
          speed = 0.6;

          fontsize = win + win * 0.1;
          // var osVer = "iPhone";
          // if (navigator.userAgent.indexOf(osVer)>0){
          //   fontsize = win + win*0.4;
          // }
        }


        function shape(x, y, texte) {
          this.x = x;
          this.y = y;
          this.size = fontsize;

          this.text = texte;
          this.placement = [];
          this.vectors = [];
        }

        shape.prototype.getValue = function () {
          // Draw the shape :^)
          ctx.textAlign = "center";
          ctx.font = fontweight + " " + this.size + "px 'Noto Sans JP'";
          ctx.fillText(this.text, this.x, this.y);
          var idata = ctx.getImageData(0, 0, W, H);
          var buffer32 = new Uint32Array(idata.data.buffer);
          // Check for black pixels
          for (var y = 0; y < H; y += gridY) {
            for (var x = 0; x < W; x += gridX) {
              if (buffer32[y * W + x]) {
                this.placement.push(new particle(x, y));
              }
            }
          }
          ctx.clearRect(0, 0, W, H);
        };
        var colors = [
          "#D9D9D9",
          "#707070",
          "#ffffff",
        ];

        function particle(x, y, type) {
          this.radius = radius;
          this.futurRadius = utils.randomInt(radius, radius + 3);

          this.rebond = utils.randomInt(1, 5);
          this.x = x;
          this.y = y;

          this.dying = false;

          this.base = [x, y];

          this.vx = 0;
          this.vy = 0;
          this.type = type;
          this.friction = 0.99;
          this.gravity = gravity;
          this.color = colors[Math.floor(Math.random() * colors.length)];

          this.getSpeed = function () {
            return Math.sqrt(this.vx * this.vx + this.vy * this.vy);
          };

          this.setSpeed = function (speed) {
            var heading = this.getHeading();
            this.vx = Math.cos(heading) * speed + scrollV;
            this.vy = Math.sin(heading) * speed + scrollV;
          };

          this.getHeading = function () {
            return Math.atan2(this.vy, this.vx);
          };

          this.setHeading = function (heading) {
            var speed = this.getSpeed();
            this.vx = Math.cos(heading) * speed;
            this.vy = Math.sin(heading) * speed;
          };

          this.angleTo = function (p2) {
            return Math.atan2(p2.y - this.y, p2.x - this.x);
          };

          this.update = function (heading) {
            this.x += this.vx;
            this.y += this.vy;
            this.vy += gravity + (scrollV ? scrollV / 10 : 0);

            this.vx *= this.friction;
            this.vy *= this.friction;

            if (this.radius < this.futurRadius && this.dying === false) {
              this.radius += duration;
            } else {
              this.dying = true;
            }

            if (this.dying === true) {
              this.radius -= duration;
            }

            ctx.beginPath();

            ctx.fillStyle = this.color;

            ctx.arc(this.x, this.y, this.radius, Math.PI * 2, false);
            ctx.fill();
            ctx.closePath();

            if (this.y < 0 || this.radius < 1) {
              this.x = this.base[0];
              this.dying = false;
              this.y = this.base[1];
              this.radius = radius;
              this.setSpeed(speed);
              this.futurRadius = utils.randomInt(radius, radius + 3);
              this.setHeading(
                utils.randomInt(utils.degreesToRads(0), utils.degreesToRads(360))
              );
            }
          };

          this.setSpeed(utils.randomInt(0.1, 0.5));
          this.setHeading(
            utils.randomInt(utils.degreesToRads(0), utils.degreesToRads(360))
          );
        }


        var message = new shape(W / 2, H / 2 + messageoffset, messagetext);


        message.getValue();

        var timer = setInterval(function () {

          if (win >= 751) {
            gridX = 15;
            gridY = 15;
          }

          if (win < 750) {
            gridX = 9;
            gridY = 9;
          }
          message.getValue();
          clearInterval(timer);
        }, 3000);

        update();

        function change() {
          ctx.clearRect(0, 0, W, H);

          gridX = parseFloat(resolution);
          gridY = parseFloat(resolution);
          message.placement = [];
          message.text = messagetext;
          message.getValue();
        }

        function changeV() {
          gravity = parseFloat(gravity);
          duration = parseFloat(duration);
          speed = parseFloat(speed);
          radius = parseFloat(raidus);
        }

        function setScrollV() {
          var nowoffset = window.pageYOffset;
          var calc = _old_offset - nowoffset;
          _old_offset = window.pageYOffset;
          return calc;
        }

        function update() {
          ctx.clearRect(0, 0, W, H);

          for (var i = 0; i < message.placement.length; i++) {
            message.placement[i].update();

          }
          scrollV = setScrollV();
          requestAnimationFrame(update);
        }
      }

      anim();
    }
  }


  growApp.prototype.parallax = function () {

    var rellax = new Rellax('.js-parallax', {
      speed: 2,
      center: false,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    });
  }

  //カウントアップ
  growApp.prototype.numberCountUp = function () {
    var win = $(window).innerWidth();
    if (win < 950) {
      return false;
    }


    //ScrollReveal
    function ScrollRevealAfterFunction() {
      window.sr = ScrollReveal({duration: 600, mobile: false});

      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }

      //カウントアップ
      sr.reveal(".js-countup-class", {
        duration: 1200, afterReveal: function (el) {
          var $el = $(el);
          $el.css("opacity", 1);
          $(".js-meter-class").addClass("is-active");

          var start_num = $el.attr("data-start") * 1;
          var end_num = $el.attr("data-end") * 1;
          var last_num = $el.attr("data-end");

          $el.text(start_num);

          var tempyear = start_num;
          var $self = $el;
          var interval = setInterval(function () {
            if (tempyear < end_num) {
              tempyear++;
              $self.text(tempyear);
              if (tempyear > last_num) {
                $self.text(last_num);
              }
            } else {
              clearInterval(interval);
              //callback();
              return false;
            }
          }, 20);

        }
      }, 150);
    }

    //実行
    ScrollRevealAfterFunction();
  }

  //ScrollReveal
  growApp.prototype.ScrollReveal = function () {
    window.sr = ScrollReveal({duration: 600, mobile: false});

    function domEach(items, callback) {
      if (typeof items === "string") {
        var items = $(items);
      }
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        // callback = callback.bind(item)
        callback(i, item);
      }
    }

    //top
    sr.reveal(".js-fade-in-bottom", {scale: 1, duration: 1000, origin: 'bottom', distance: '30px',}, 100);

    //lower
    sr.reveal(".l-page-header__title,.l-page-header__subtitle,.c-hero-block__block", {
      scale: 1,
      duration: 1000,
      origin: 'bottom',
      distance: '30px',
    }, 100);


    var blocks01 = $(".c-structure__image-pc,.c-recruit-person__blocks");
    domEach(blocks01, function (key, item) {
      sr.reveal(item, {scale: 1, duration: 400, delay: 400}, 200);
      sr.reveal(item.children[1], {delay: 400, duration: 1000, scale: 1, distance: '30px'}, 300);
      sr.reveal(item.children[2], {delay: 500, duration: 1000, scale: 1, distance: '30px'}, 300);
      sr.reveal(item.children[3], {delay: 600, duration: 1000, scale: 1, distance: '30px'}, 300);
      sr.reveal(item.children[4], {delay: 700, duration: 1000, scale: 1, distance: '30px'}, 300);
      sr.reveal(item.children[5], {delay: 800, duration: 1000, scale: 1, distance: '30px'}, 300);
      sr.reveal(item.children[6], {delay: 900, duration: 1000, scale: 1, distance: '30px'}, 300);
      sr.reveal(item.children[7], {delay: 1000, duration: 1000, scale: 1, distance: '30px'}, 300);
      sr.reveal(item.children[8], {delay: 1100, duration: 1000, scale: 1, distance: '30px'}, 300);
    });

    var blocks01 = $(".c-resolution__point");
    domEach(blocks01, function (key, item) {
      sr.reveal(item, {scale: 1, duration: 1400, delay: 400}, 200);
      sr.reveal(item.children[1], {delay: 800, duration: 1400, scale: 1, distance: '30px'}, 300);
      sr.reveal(item.children[2], {delay: 900, duration: 1400, scale: 1, distance: '30px'}, 300);
      sr.reveal(item.children[3], {delay: 1000, duration: 1400, scale: 1, distance: '30px'}, 300);
      sr.reveal(item.children[4], {delay: 1100, duration: 1400, scale: 1, distance: '30px'}, 300);
    });

    var blocks02 = $(".c-infographics-hobby__images");
    domEach(blocks02, function (key, item) {
      sr.reveal(item, {scale: 1, duration: 100, delay: 200}, 200);
      sr.reveal(item.children[1], {delay: 400, duration: 800, scale: 0.5, distance: '0px'}, 300);
      sr.reveal(item.children[2], {delay: 500, duration: 800, scale: 0.5, distance: '0px'}, 300);
      sr.reveal(item.children[3], {delay: 600, duration: 800, scale: 0.5, distance: '0px'}, 300);
      sr.reveal(item.children[4], {delay: 700, duration: 800, scale: 0.5, distance: '0px'}, 300);
      sr.reveal(item.children[5], {delay: 800, duration: 800, scale: 0.5, distance: '0px'}, 300);
      sr.reveal(item.children[6], {delay: 900, duration: 800, scale: 0.5, distance: '0px'}, 300);
      sr.reveal(item.children[7], {delay: 1000, duration: 800, scale: 0.5, distance: '0px'}, 300);
    });
  }

  //mainAnim
  growApp.prototype.mainAnim = function () {
    //変数宣言
    let videoObj = document.getElementById("top-video"); //video
    let videoEndTime; //ビデオの長さを格納する変数
    let $overlayFirstCopy = $(".c-main-visual__overlay-first-copy"); //最初のコピー
    let $overlayFirst = $(".c-main-visual__overlay-first"); //最初のオーバーレイ
    let $overlayMugen = $(".c-main-visual__overlay-mugen"); //拡大して消えるオーバーレイ
    let $video = $(".c-main-visual__video"); //ビデオ

    if (videoObj) {

      //実行
      anim();
      animLoopFunction();

      //アニメーション全体の処理
      function anim() {
        /*
        1 firstオーバーレイのテキストが現れ
        2 firstオーバーレイが消える
        3 無限オーバーレイが現れる ビデオが再生
        4 無限オーバーレイが拡大しながら画面外に消える
        きっかけはjs
        タイミングはcssアニメーションで調整
         */

        //実行
        anim1st(anim2th);

        //処理1
        function anim1st(callback) {

          $overlayFirstCopy.fadeIn(600, function () {

            $(".c-main-visual__overlay-first-copy").stop(true).animate({
            }, 900, function () {
              $(".c-main-visual__overlay-first-copy").stop(true).animate({
              }, 2000, function () {
                //$(this).addClass('is-shrink');
                callback();
              });
            });
          }).addClass('is-active-lg');
        }

        //処理2 コールバック
        function anim2th() {
          videoEndTime = videoObj.duration; //ビデオの長さを格納
          $overlayFirst.fadeOut(1200, function () {
            $overlayMugen.addClass("is-action");
            $video.addClass("is-fadein");
          });
        }
      }

      //アニメーションループ処理
      function animLoopFunction() {
        videoObj.play(); //動画再生
      }

      //動画が終わったタイミングで発火 初期化と、ループ
      videoObj.addEventListener("ended", function () {
        animLoopFunction(); //初期化とアニメーションループ
      }, false);

      //動画の再生秒数を監視して、終了処理
      // videoObj.addEventListener("timeupdate", function (e) {
      //     let currentTime = Math.ceil(videoObj.currentTime); // 現在の再生秒数格納
      //     if (currentTime >= (videoEndTime - 2)) {
      //         //$overlayFirstCopy.fadeOut(1000);
      //         //$overlayFirst.fadeIn(2000);
      //     }
      // }, false);


      //初期化処理
      // function init(callback) {
      //     $overlayMugen.removeClass("is-action");
      //     $overlayMugen.css({
      //         'display': 'block',
      //         'opacity': '1',
      //         'transform': 'scale(1, 1)'
      //     });
      //     $video.removeClass("is-fadein");
      //     $overlayFirst.css({
      //         'display': 'block'
      //     });
      //     $overlayFirstCopy.css({
      //         'top': '50%',
      //         'font-size': '40px',
      //         'display': 'none',
      //         'transform': 'translateX(-50%) translateY(-50%) scale(0)'
      //     }).removeClass("is-active-lg");
      //     //アニメーションループのコールバック関数
      //     callback();
      // }
    }
  }

  growApp.prototype.matchHeight = function () {
    if ($('.c-news-block__block').length <= 0) {
      return false;
    }
    $('.c-news-block__block').matchHeight();
  }

  growApp.prototype.headerImageBlur = function () {
    if ($('.l-page-header__image-img').length <= 0) {
      return false;
    }
    var userAgent = window.navigator.userAgent.toLowerCase();
    // IEの場合のみ対応
    if(userAgent.indexOf('msie') == -1 &&
      userAgent.indexOf('trident') == -1 ) {
      return false;
    }


    !function(t){"use strict";function e(e){return this.each(function(){var i=t(this),n=i.data("plugin.backgroundBlur"),o=t.extend({},r.DEFAULTS,i.data(),"object"==typeof e&&e);n||i.data("plugin.backgroundBlur",n=new r(this,o)),"fadeIn"===e?n.fadeIn():"fadeOut"===e?n.fadeOut():"string"==typeof e&&n.generateBlurredImage(e)})}var i=function(){for(var t,e=3,i=document.createElement("div"),n=i.getElementsByTagName("i");i.innerHTML="<!--[if gt IE "+ ++e+"]><i></i><![endif]-->",n[0];);return e>4?e:t}(),n=function(){return"_"+Math.random().toString(36).substr(2,9)},o={svgns:"http://www.w3.org/2000/svg",xlink:"http://www.w3.org/1999/xlink",createElement:function(t,e){var i=document.createElementNS(o.svgns,t);return e&&o.setAttr(i,e),i},setAttr:function(t,e){for(var i in e)"href"===i?t.setAttributeNS(o.xlink,i,e[i]):t.setAttribute(i,e[i]);return t}},r=function(e,i){this.internalID=n(),this.$element=t(e),this.$width=this.$element.width(),this.$height=this.$element.height(),this.element=e,this.options=t.extend({},r.DEFAULTS,i),this.$overlayEl=this.createOverlay(),this.$blurredImage={},this.useVelocity=this.detectVelocity(),this.attachListeners(),this.generateBlurredImage(this.options.imageURL)};r.VERSION="0.1.1",r.DEFAULTS={imageURL:"",blurAmount:10,imageClass:"",overlayClass:"",duration:!1,opacity:1},r.prototype.detectVelocity=function(){return!!window.jQuery.Velocity},r.prototype.attachListeners=function(){this.$element.on("ui.blur.loaded",t.proxy(this.fadeIn,this)),this.$element.on("ui.blur.unload",t.proxy(this.fadeOut,this))},r.prototype.fadeIn=function(){this.options.duration&&this.options.duration>0&&(this.useVelocity?this.$blurredImage.velocity({opacity:this.options.opacity},{duration:this.options.duration}):this.$blurredImage.animate({opacity:this.options.opacity},{duration:this.options.duration}))},r.prototype.fadeOut=function(){this.options.duration&&this.options.duration>0?this.useVelocity?this.$blurredImage.velocity({opacity:0},{duration:this.options.duration}):this.$blurredImage.animate({opacity:0},{duration:this.options.duration}):this.$blurredImage.css({opacity:0})},r.prototype.generateBlurredImage=function(t){var e=this.$blurredImage;this.internalID=n(),e.length>0&&(this.options.duration&&this.options.duration>0?this.useVelocity?e.first().velocity({opacity:0},{duration:this.options.duration,complete:function(){e.remove()}}):e.first().animate({opacity:0},{duration:this.options.duration,complete:function(){e.remove()}}):e.remove()),i?this.$blurredImage=this.createIMG(t,this.$width,this.$height):this.$blurredImage=this.createSVG(t,this.$width,this.$height)},r.prototype.createOverlay=function(){return this.options.overlayClass&&""!==this.options.overlayClass?t("<div></div>").prependTo(this.$element).addClass(this.options.overlayClass):!1},r.prototype.createSVG=function(e,i,n){var r=this,s=o.createElement("svg",{xmlns:o.svgns,version:"1.1",width:i,height:n,id:"blurred"+this.internalID,"class":this.options.imageClass,viewBox:"0 0 "+i+" "+n,preserveAspectRatio:"none"}),a="blur"+this.internalID,u=o.createElement("filter",{id:a}),l=o.createElement("feGaussianBlur",{"in":"SourceGraphic",stdDeviation:this.options.blurAmount}),h=o.createElement("image",{x:0,y:0,width:i,height:n,externalResourcesRequired:"true",href:e,style:"filter:url(#"+a+")",preserveAspectRatio:"none"});h.addEventListener("load",function(){r.$element.trigger("ui.blur.loaded")},!0),h.addEventListener("SVGLoad",function(){r.$element.trigger("ui.blur.loaded")},!0),u.appendChild(l),s.appendChild(u),s.appendChild(h);var d=t(s);return r.options.duration&&r.options.duration>0&&(d.css({opacity:0}),window.setTimeout(function(){"0"===d.css("opacity")&&d.css({opacity:1})},this.options.duration+100)),this.element.insertBefore(s,this.element.firstChild),d},r.prototype.createIMG=function(t,e,i){var n=this,o=this.prependImage(t),r=2*this.options.blurAmount>100?100:2*this.options.blurAmount;return o.css({filter:"progid:DXImageTransform.Microsoft.Blur(pixelradius="+r+") ",top:2.5*-this.options.blurAmount,left:2.5*-this.options.blurAmount,width:e+2.5*this.options.blurAmount,height:i+2.5*this.options.blurAmount}).attr("id","blurred"+this.internalID),o.load(function(){n.$element.trigger("ui.blur.loaded")}),this.options.duration&&this.options.duration>0&&window.setTimeout(function(){"0"===o.css("opacity")&&o.css({opacity:1})},this.options.duration+100),o},r.prototype.prependImage=function(e){var i,n=t('<img src="'+e+'" />');return i=this.$overlayEl?n.insertBefore(this.$overlayEl).attr("id",this.internalID).addClass(this.options.imageClass):n.prependTo(this.$element).attr("id",this.internalID).addClass(this.options.imageClass)};var s=t.fn.backgroundBlur;t.fn.backgroundBlur=e,t.fn.backgroundBlur.Constructor=r,t.fn.backgroundBlur.noConflict=function(){return t.fn.backgroundBlur=s,this}}(jQuery);

    var image_url = $('.l-page-header__image-img').attr("data-background-image-url");
    $('.l-page-header__image-img').css("background-image","");
    $('.l-page-header__image-img').backgroundBlur({
      imageURL : image_url,
      blurAmount : 10
    });

  }

  $(function () {
    var app = new growApp();
    // app.changeViewPort();
    // app.menuHight();
    app.footerMenu();
    app.slick();
    app.mainAnim(); //メインビジュアル処理
    var timer = setInterval(function () {
      app.particleAnim(); //パーティクル処理
      clearInterval(timer);
    }, 1400);

    app.buttonWrap();
    //app.typreWrite();
    // app.parallax();
    app.numberCountUp();
    app.ScrollReveal();
    app.matchHeight();
    app.headerImageBlur();

  });

})(jQuery);
